import { trackCioEvent } from '../cio';
import { AnalyticsEvent } from '../types';

export function trackOrderRejected() {
  trackCioEvent(AnalyticsEvent.DTC_ORDER_REJECTED);
}
